// src/components/ToastNotification.js
import React from 'react'
import { Toast, ToastContainer } from 'react-bootstrap'
import useToastStore from '../../stores/toastStore' // Adjust the path as needed

const ToastNotification = () => {
    const { toasts, removeToast } = useToastStore()

    return (
        <ToastContainer className="position-static">
            {toasts.length > 0 && (
                <Toast
                    key={0}
                    onClose={() => removeToast(0)}
                    show={true}
                    delay={5000}
                    autohide
                    className={`toast-${toasts[0].variant}`}
                >
                    <Toast.Body>
                        {toasts.map((t, ti) => (
                            <React.Fragment key={ti}>
                                {t.message}
                                <br />
                            </React.Fragment>
                        ))}{' '}
                    </Toast.Body>
                </Toast>
            )}
        </ToastContainer>
    )
}

export default ToastNotification
